export type ItamProductContext = 'ham'; // only ham is supported for now; sam and cam can be added later

export const ITAM_PRACTICE_HAM = 'ham' as const;
